// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"296":"final","443":"about"}[chunkId] + "." + {"296":"907954f6","443":"22a8d94b"}[chunkId] + ".js";
};